import React from "react";
//#region types
import { TranslationKeys } from "translations";
import { DimensionSelectionGroupProps } from "models/propTypes/dimensionPropTypes";
//#endregion
//#region components
import DialogEvents from "../../../dialogs/dialogEvents";
import SelectionGroup from "../../../selection/selectionGroup";
import DimensionSelectDialog from "../../../dimensions/dimensionSelectDialog";
//#endregion
import { DimensionHelper, LocalizationHelperInstance } from "utils/helpers";

const DimensionSelectionGroup: React.FC<DimensionSelectionGroupProps> = (props) => {
  const {
    dimensionType,
    onSelectionChange,
    onViewAllClick,
    viewAllButtonText,
    enableSingleSelectionMode,
    hideSelectionDialogFooter,
    dimensionPresetType,
    amount,
    currency,
    readonly,
    disabled,
    hideViewAll,
    fileViewer,
  } = props;

  return (
    <DialogEvents
      render={(isOpen, openDialog, closeDialog, key) => (
        <>
          <SelectionGroup
            title={DimensionHelper.getDimensionTypeText(dimensionType.type, dimensionType.name)}
            key={dimensionType.id}
            items={dimensionType.suggestions.slice(0, 2)}
            onChange={onSelectionChange.bind(null, dimensionType.id, true, true)}
            onViewAllClick={onViewAllClick ?? openDialog}
            value={readonly || disabled ? dimensionType.selectedDimensions : []}
            viewAllText={
              viewAllButtonText ?? LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Advanced)
            }
            alwaysDisplayViewAll
            isReadOnly={readonly}
            disabled={disabled}
            hideOthersOnSelection
            hideViewAll={hideViewAll}
          />
          <DimensionSelectDialog
            key={key}
            isOpen={isOpen}
            dimensionType={dimensionType.id}
            dimensionTypeName={dimensionType.name}
            dimensionCompatibilityType={dimensionType.type}
            selectItemsHandler={onSelectionChange.bind(null, dimensionType.id, false, false)}
            dimensionSuggestions={dimensionType.suggestions}
            allDimensions={dimensionType.all}
            cancelHandler={closeDialog}
            amount={amount}
            currency={currency}
            selectedItems={dimensionType.selectedDimensions}
            dimensionPresetType={dimensionPresetType}
            enableSingleSelectionMode={enableSingleSelectionMode}
            hideFooter={hideSelectionDialogFooter}
            fileViewer={fileViewer}
          />
        </>
      )}
    />
  );
};

export default DimensionSelectionGroup;
